import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"

const CorporateDashboardSkeletonConfig = [
    {
        columns: [
            {
                span: 24,
                rows: [
                    { span: 24, height: "250px" },
                    { span: 22, height: "96px", classes: "marginTop-64 marginLeft-auto marginRight-auto  " },
                    { span: 22, height: "420px", classes: "marginTop-64 marginLeft-auto marginRight-auto " },
                ],
            },
        ],
    },
]

function DashboardSkeleton() {
    return (
        <div className="page-container">
            <Skeleton config={CorporateDashboardSkeletonConfig}></Skeleton>
        </div>
    )
}

export default DashboardSkeleton
